import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tc-portal-login',
  templateUrl: './tc-portal-login.component.html',
  styleUrls: ['./tc-portal-login.component.scss']
})
export class TcPortalLoginComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
